import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';
import type { ProductsMiniCarouselProps } from './component';

const ComponentLoad = lazy(async () => await import('./component'));

const ProductsMini: FC<ProductsMiniCarouselProps> = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(ProductsMini);
